export const GET_VAT_TYPES = 'GET_VAT_TYPES'
export const GET_VAT_TYPES_SUCCESS = 'GET_VAT_SUCCESS_TYPES'
export const GET_VAT_TYPES_FAILED = 'GET_VAT_FAILED_TYPES'
